import React from 'react';
import classNames from 'classnames';

import type { PublicUser } from 'js/src/client';
import Avatar from 'js/src/components/common/ui/Avatar';
import type { ImmutableMap } from 'js/src/libs/consts';
import { getUserInitials } from 'js/src/libs/custom-utils';

type Props = {
    user: ImmutableMap<PublicUser>;
    className?: string;
    bioLine?: string;
};

const UserInformationDisplay = React.memo(function UserInformationDisplay({
    user,
    className,
    bioLine = '',
}: Props) {
    return (
        <div
            className={classNames('user-information-display d-flex align-items-center', className)}
        >
            <div className="me-l5-8">
                <Avatar
                    image={user.get('photo_url')}
                    text={getUserInitials(user.get('first_name'))}
                    size="large"
                />
            </div>
            <div className="ms-l5-8">
                <h5>
                    {user.get('first_name')} {user.get('last_name')}
                </h5>
                <span className="font-l5 font-l5--small">{bioLine}</span>
            </div>
        </div>
    );
});

export default UserInformationDisplay;
